import MenuItem from "@mui/material/MenuItem";
import {can} from "./Permission";

const PermissionMenuItem = ({title, onPress, permission, shopId, visible=false, icon, ...otherProps}) => {

    const allow = can(permission, shopId)

    if (!allow && visible === false) return null

    return (
        <MenuItem
            onClick={onPress}
            disabled={!allow && visible}
            {...otherProps}
            target="_blank"
        >
            {icon}
            {title}
        </MenuItem>
        
    )
}

export default PermissionMenuItem